function DropdownMenu(props) {
    const items = Object.keys(props.groups);
    return (
    <select value={props.value} 
    onChange={e => props.setValue(e.target.value)}
    defaultValue="all" name="selectedCountry">

    <option value="all">All Countries</option>
    {items.map((options) => (
        <option key={options} value={options}>{options}</option>
    ))}

    </select>
    )
}
export default DropdownMenu;